module.exports = __webpack_public_path__ + "static/img/online_pic4.40c99f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_pic4.jpg
// module id = xLhW
// module chunks = 21